import { Theme } from '@ttoss/ui';

const theme = {
  breakpoints: ['42em', '60em', '65em'],
  space: [0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, 144, 233, 377, 610, 987],
  fonts: {
    body: 'Overlock',
    heading: 'Josefin Sans',
  },
  fontSizes: [7, 10, 12, 17, 22, 29, 39, 51, 68, 90],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 900,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  radii: {
    none: 0,
    partial: 6,
    full: '100%',
  },
  borderWidths: [0, '1px'],
  colors: {
    transparent: '#ffffff00',
    primary: '#127547',
    secondary: '#457F8D',
    text: '#393A3A',
    background: '#F7F9F8',
    accent: '#00C7FE',
    highlight: '#0067D2',
    muted: '#B9B9B9',
    primaryVariant: '#008774',
    secondaryVariant: '#7AB4C3',
    alert: '#FF655B',
    success: '#66AA00',
    caution: '#FC6C00',
    neutral: '#888888',
    eucalipto: '#E79E49',
    pinus: '#EBC36D',
    cedroAustraliano: '#9F4F2A',
    mognoAfricano: '#C18771',
    teca: '#C19358',
    dark: '#000000',
  },
  shadows: [
    '0',
    '0px 4px 4px rgba(0, 0, 0, 0.15)',
    '0px 2px 6px rgba(0, 0, 0, 0.15), 0px -2px 6px rgba(0, 0, 0, 0.15)',
  ],
  sizes: { container: '68em' },
  zIndices: [0, 10, 100, 1000],
  styles: {
    root: {
      fontFamily: 'body',
      fontWeight: 'body',
    },
    hr: {
      color: 'muted',
    },
  },
  text: {
    error: {
      color: 'alert',
      fontSize: [1, 2],
    },
  },
  'input-search': {
    color: 'text',
    '::placeholder': {
      color: 'muted',
    },
    fontSize: 3,
    paddingLeft: 5,
    paddingRight: 8,
    fontStyle: 'normal',
    fontWeight: 'body',
    lineHeight: 'heading',
    fontFamily: 'body',
    borderColor: 'muted',
    borderWidth: 2,
    ':focus-within': {
      borderColor: 'muted',
      outline: 0,
    },
  },
  forms: {
    label: {
      fontSize: [2, 3],
      fontFamily: 'body',
      color: 'primaryVariant',
      ':has(input[type="radio"])': {
        fontSize: 3,
        color: 'text',
      },
      '&[aria-disabled="true"]': {
        color: 'muted',
      },
    },
    select: {
      height: 35,
      fontSize: 2,
      color: 'text',
      paddingTop: '10px',
      paddingLeft: '15px',
      paddingBottom: '11px',
      paddingRight: '14px',
      borderColor: 'muted',
    },
    radio: {
      color: 'dark',
      marginRight: 6,
      width: 16,
      height: 16,
    },
    checkbox: {
      color: 'primary',
      marginRight: 6,
      width: 14,
      height: 14,
    },
    input: {
      border: 0,
      background: 'background',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: 'primaryVariant',
      borderRadius: 0,
      fontSize: [2, 3],
      paddingBottom: 4,
      paddingX: 5,
      marginTop: 5,
      color: 'text',
      fontFamily: 'body',
      ':focus-within': {
        outline: 0,
      },
      ':disabled': {
        borderBottomColor: 'muted',
        color: 'muted',
      },
    },
  },
};

export default theme;

export type MyTheme = Theme & typeof theme;
